import React from "react";
import "../Styles/Overview.scss";

const Overview = ({ content }) => {
  return (
    <div className="overview-wrapper">
      {/* Structural Stage for Overview Section on Desktop */}
      <div className="workstation-screen-stage" />

      {/* Responsive Apple Spatial Preview Card for Mobile & Tablet (< 1024px) */}
      {content && (
        <div className="mobile-overview-card">
          <div className="mobile-card-badge-row">
            <span className="mobile-card-tag">{content.title || "Product Overview"}</span>
            <span className="mobile-card-dot">• •</span>
          </div>

          <h3 className="mobile-card-headline">{content.headline}</h3>
          <p className="mobile-card-desc">{content.description}</p>

          <div className="mobile-preview-frame">
            <img
              key={content.screenURL || content.imageURL}
              src={content.screenURL || content.imageURL}
              alt={content.title || "Product Preview"}
              className="mobile-preview-img"
              loading="eager"
            />
          </div>

          {content.buttons && content.buttons.length > 0 && (
            <div className="mobile-card-buttons">
              {content.buttons.map((btnText, i) => (
                <span key={i} className="mobile-pill-tag">
                  {btnText}
                </span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Overview;
